import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { connect } from "scrivito"
import { FileUpload } from "shared/ui/file-upload/FileUpload"

import { useProductPageContext } from "../context/ProductPageContext"

type ProductPageDownloadsProps = Omit<
  React.ComponentPropsWithoutRef<"section">,
  "ref"
> & {
  productType: string
  parentProductType?: string
}

function ProductPageDownloadsComponent({
  productType,
  parentProductType,
  className,
  ...rest
}: ProductPageDownloadsProps) {
  const { t } = useTranslation()
  const { getFiles } = useProductPageContext()
  const files = getFiles({ productType, parentProductType })

  if (!files || files.length === 0) {
    return null
  }

  return (
    <section
      {...rest}
      className={classNames(
        "product-page__downloads product-page__section card card--elevated",
        className
      )}
    >
      <h3 className="product-page__section-title">
        {t("Product.Information.Downloads")}
      </h3>
      <FileUpload.Root
        className="technical-documentation-list"
        files={files}
        target="_blank"
        isReadonly
      >
        <FileUpload.List />
      </FileUpload.Root>
    </section>
  )
}

export const ProductPageDownloads = React.memo(
  connect(ProductPageDownloadsComponent)
)
